export default "/images/b92fcc2d070b5882674a6fc709b56078.avif";